import { render } from "./AnimatedCharacter.vue?vue&type=template&id=dfd4995a"
import script from "./AnimatedCharacter.vue?vue&type=script&lang=ts"
export * from "./AnimatedCharacter.vue?vue&type=script&lang=ts"

import "./AnimatedCharacter.vue?vue&type=style&index=0&id=dfd4995a&lang=css"
script.render = render

export default script